<template>
    <div id="select-medication-dialog" class="select-button d-flex">
        <div class="input-wrapper d-flex">
            <b-form-input class="medication-input" :value="getValue" type="text" readonly="readonly" :required="required"/>
            <label class="smooth-label" :class="{'required': required}">{{label ? label : "Gyógyszer"}}</label>
        </div>

        <div class="icon-wrapper" ref="copyWrapper" @click="showDialog">
            <span><i class="fas fa-search"></i></span>
        </div>

        <b-modal id="drug-select-modal" size="xl" lazy ref="bno-select-dialog" title="Gyógyszer kiválasztása">
            <b-tabs content-class="mt-3" lazy>
                <b-tab title="Összes" active>
                    <div class="d-block" :style="cssVars">
                        <DataTable ref="dataTable"
                                   :columns="getHeaderFields"
                                   :rowActions="getRowActions"
                                   :additional-config="getDataTableOptions"
                                   :apiCallback="getValidMedications"
                                   @customClick="buttonWasClicked"/>
                    </div>
                </b-tab>
            </b-tabs>

            <template slot="modal-footer" slot-scope="{ cancel }">
                <b-button size="sm" variant="danger" @click="hideDialog">
                    <i class="far fa-times-circle"></i> Bezár
                </b-button>
            </template>
        </b-modal>

    </div>
</template>

<script>
    import Api from "../util/Api";
    import {mapGetters} from "vuex";
    import DataTable from "../components/DataTable";

    export default {
        name: "SelectMedicationSingleDialog",
        components: {
            DataTable
        },
        data() {
            return {
                selectedValue: ''
            }
        },
        props: {
            value: {type: [Object, String, Number]},
            options: {type: Object},
            required: {type: Boolean, default: false},
            label: {type: String, default: null},
            readOnly: {type: Boolean, default: false},
        },
        computed: {
            ...mapGetters("medicationSelectSingleDialog", ["getHeaderFields", "getRowActions", "getDataTableOptions"]),
            ...mapGetters("app", ['getDefaultColor']),

            getValue: function () {
                if (this.options.formatText && this.selectedValue) { //ha van formázó fv a kiváklasztott elemre azt használja
                    return this.options.formatText(this.selectedValue);
                } else {
                    return this.selectedValue;
                }
            },

            cssVars() {
                return {
                    '--default-color': this.getDefaultColor
                }
            },
        },
        methods: {
            showDialog() {
                if (!this.readOnly) {
                    this.$refs['bno-select-dialog'].show();
                }
            },
            hideDialog() {
                this.$refs['bno-select-dialog'].hide();
            },

            selectRow(rowData) {
                this.selectedValue = rowData;
                
                if (this.options.returnValue) {
                    // ha nem objektummal hanem egy adattagjával szeretnénk visszatérni
                    this.$emit('input', rowData[this.options.returnValue]);
                } else {
                    this.$emit('input', rowData);
                }

                this.hideDialog();
                
            },

            getValidMedications(params) {
                params.params.filter = {
                    ...params.params.filter,
                    ...this.searchFormData
                };
                return Api.getAllPuphaxTermek(params);
            },

            refreshGrid() {
                this.$refs.dataTable.fetchData();
            },

            buttonWasClicked(event, data) {
                switch (event.event_payload) {
                    case "selectRow":
                        this.selectRow(data);
                        break;
                }
            }

        },
        created() {
            if (this.value) {
                let self = this;
                let params = {
                    params: {
                        kod: this.value
                    }
                };
                Api.getBnoByKod(params)
                    .then(resp => {
                        self.selectedValue = resp.data;
                        this.$emit('input', self.selectedValue);
                    })
                    .catch(errMsg => {
                        console.error(errMsg);
                    })
            }
        },
        watch: {
            value: {
                deep: true,
                handler: function (val) {
                    let self = this;
                    if(!self.options.returnValue){
                        self.selectedValue = val;
                    } else {
                        // TODO: Ha van olyan ahol kintről jön adat és nem teljes object-tel térünk vissza
                        // let params = {
                        //     params: {
                        //         pageIndex: 0,
                        //         filter: {},
                        //         sort: {}
                        //     }
                        // }
                        // self.apiCallback(params).then(data => {
                        // })
                    }
                }
            }
        }
    }
</script>

<style scoped>
    .icon-wrapper {
        height: 38px !important;
        padding: 0.25rem 0.5rem;
        font-size: 1rem;
        line-height: 1.6;
        border-top: 1px solid #ced4da;
        border-right: 1px solid #ced4da;
        border-bottom: 1px solid #ced4da;
        border-top-right-radius: 0.2rem;
        border-bottom-right-radius: 0.2rem;
        cursor: pointer;
    }

    .input-wrapper {
        position: relative;
        flex: 1;
    }

    .medication-input {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
    }
</style>
